import type { Href } from 'expo-router';

export function validatedInternalReturnPath(value: string | string[] | undefined): string | null {
  const candidate = Array.isArray(value) ? value[0] : value;
  if (!candidate || candidate.length > 1_024) return null;
  if (!candidate.startsWith('/') || candidate.startsWith('//')) return null;
  if (candidate.includes('\\') || /[\u0000-\u001f\u007f]/.test(candidate)) return null;

  try {
    const parsed = new URL(candidate, 'https://6amrun.club');
    if (parsed.origin !== 'https://6amrun.club') return null;
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return null;
  }
}

export function authDestination(value: string | string[] | undefined): Href {
  return (validatedInternalReturnPath(value) ?? '/app') as Href;
}

export function signInHref(returnTo?: string | null): Href {
  const safeReturnTo = validatedInternalReturnPath(returnTo ?? undefined);
  return safeReturnTo
    ? { pathname: '/(public)/sign-in', params: { returnTo: safeReturnTo } }
    : '/(public)/sign-in';
}

export function signUpHref(returnTo?: string | null): Href {
  const safeReturnTo = validatedInternalReturnPath(returnTo ?? undefined);
  return safeReturnTo
    ? { pathname: '/(public)/sign-up', params: { returnTo: safeReturnTo } }
    : '/(public)/sign-up';
}
